<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Imported Data Detail</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <!-- Form -->
          <div class="row align-items-center mt-2">
            <div class="col-md-2">Employee</div>
            <div class="col-md-2 pl-md-0">
              <select class="custom-select" v-model="employeeID">
                <option value="All">All</option>
                <option v-for="employee in employees" :key="employee.EmployeeID" :value="employee.EmployeeID">
                  {{ employee.Text }}
                </option>
              </select>
            </div>
          </div>

          <div class="row align-items-center mt-3">
            <div class="col-md-12">
              <button type="button" class="btn btn-primary" @click="search">Search</button>
              <span v-if="employeeID != 'All' && hasSearch">
                &nbsp;
                <button type="button" class="btn btn-danger" @click="overwrite">Overwrite</button>
              </span>
            </div>
          </div>
        </div>
        <!-- /Form -->

        <div class="col-md-12">
          <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
            
            <table class="table table-bordered custom-table mb-0">
              <thead class="thead-light">
                <tr>
                  <th class="group-column">Date</th>
                  <th class="group-column">EmployeeID</th>
                  <th class="group-column">Imported Hours Mon-Sat</th>
                  <th class="group-column">Imported Hours Sun & PH</th>
                  <th class="group-column">Fab</th>
                  <th class="group-column">Service Order</th>
                  <th class="group-column">Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in record" :key="index">
                  <td class="action-column">{{ data.CADODateDisplay }}</td>
                  <td class="action-column">{{ data.EmployeeID }}</td>
                  <td class="group-column">{{ data.ImportedHoursMonSat }}</td>
                  <td class="group-column">{{ data.ImportedHoursSunPH }}</td>
                  <td class="group-column">{{ data.Fab }}</td>
                  <td class="group-column">{{ data.ServiceOrder }}</td>
                  <td class="group-column">{{ data.Purpose }}</td>
                </tr>
                
                <tr v-if="record && !record.length">
                  <td colspan="7" class="text-center">{{ this.noRecordText }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
  data() {
    return {
      id: "",
      employees: [],
      employeeID: "All",
      record: [],
      hasSearch: false,
      status: config.TIMESHEET_STATUS_DRAFT,
      noRecordText: config.NO_RECORD_TEXT,
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getEmployees() {
        let param = {
            Token: this.token,
            Id: this.id
        };

        this.$store.state.isLoading = true;
        API.getImportEmployees(param)
        .then((response) => {
            if ( response.data.success ) {
                this.$store.state.isLoading = false;
                this.employees = response.data.record;

                this.search();

                // console.log(employees);
            } else {
                this.$swal(response.data.message, { icon: "error" });
            }
        })
        .catch((error) => {
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    overwrite() {
        let param = {
            Token: this.token,
            CADOImportId: this.id,
            EmployeeID: this.employeeID
        };

        this.$swal({
            title: "Are you sure?",
            text: "You are going to overwrite the employee's timesheet. Click OK to continue.",
            icon: "info",
            buttons: true,
            dangerMode: false,
        }).then((willSave) => {
            if (willSave) {
                this.$store.state.isLoading = true;
                API.overwriteImportedEmployeeData(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    this.$swal(response.data.message, {
                        icon: response.data.success ? "success" : "error",
                    });
                })
                .catch((error) => {
                    //console.log(error);
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
            }
        });
    },
    search() {
      let param = {
        Token: this.token,
        EmployeeID: this.employeeID,
        CADOImportId: this.id
      };
      this.$store.state.isLoading = true;
      API.searchImportDetailList(param)
        .then((response) => {
          if (response.data.success) {
            if ( response.data.isEmpty ) {
              this.record = [];
            }
            else {
              this.record = response.data.record;
            }

            if ( this.employeeID != 'All' ) {
                this.hasSearch = true;
            }
            else {
                this.hasSearch = false;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          this.$store.state.isLoading = false;
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    }
  },

  created() {
    if ( this.$route.params.id && this.$route.params.id != "" ) {
        this.id = this.$route.params.id;
    }
    else {
        this.$router.replace({ name: "home" });
    }

    this.getEmployees();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Attendance/CADOImportDetail.vue